import DMCAContract from '../contracts/DMCAContract.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import EthereumQuery from '../EthereumQuery.js';
import {SampleCopyStrike, SampleTakenDown} from '../EthereumEvents.js';
import ipfs from '../Ipfs.js';

const dmcaContract = new DMCAContract();

class DMCA {
    constructor(web3) {
        this.web3 = web3;
        this.contract = dmcaContract.getContract(web3);
        this.contractAddress = dmcaContract.contractAddress;
    }

    async getCopyStrikedSamples() {
        let query = new EthereumQuery(this.contractAddress)
            .from(SampleCopyStrike)
            .select('sampleHash')
            .select('reasoningHash');

        let results = await query.executeQuery();
        return results;
    }

    async getTakenDownSamples() {
        let query = new EthereumQuery(this.contractAddress)
            .from(SampleTakenDown)
            .select('sampleHash');

        let results = await query.executeQuery();
        return results;
    }

    copyStrikeSample(sampleHash, emailAddress, reasoningText) {
        return new Promise(async (resolve, reject) => {
            const accounts = await this.web3.eth.getAccounts();
            let reasoningJson = {
                reasoning: reasoningText,
                emailAddress: emailAddress,
            };
            
            // use central ipfs so messages are actually saved correctly
            let reasoningHash = await ipfs.addJson(reasoningJson, true);
            reasoningHash = ipfsHashToBytes32(reasoningHash);
            sampleHash = ipfsHashToBytes32(sampleHash);
            
            this.contract.methods.copyStrikeSample(sampleHash, reasoningHash).send({
                from: accounts[0] 
            }, (error, transactionHash) => {
                if (error) {
                    reject();
                } else {
                    resolve();
                }
            });
        });
    }

    takeDownSample(sampleHash) {
        return new Promise(async (resolve, reject) => {
            const accounts = await this.web3.eth.getAccounts();
            sampleHash = ipfsHashToBytes32(sampleHash);
            
            this.contract.methods.takedownSample(sampleHash).send({
                from: accounts[0] 
            }, (error, transactionHash) => {
                if (error) {
                    reject();
                } else {
                    resolve();
                }
            });
        });
    }
}

export default DMCA;
